/**
 * Defines the roles in the system.
 */
export enum RoleType {
    // Не определено
    Undefined = "undefined",

    // Администратор
    Admin = "admin",

    // Диспетчер
    Dispatcher = "dispatcher",

    // Медицинский работник
    Medic = "medic",

    // Водитель
    Driver = "driver",
}

export function getRoleString(role: RoleType): string {
    switch (role) {
        case RoleType.Admin:
            return 'Администратор';
        case RoleType.Dispatcher:
            return 'Диспетчер';
        case RoleType.Medic:
            return 'Медицинский работник';
        case RoleType.Driver:
            return 'Водитель';
        case RoleType.Undefined:
        default:
            return 'Пользователь';
    }
}